// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.model-cover {
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  left: 0;
  padding: 0 15px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999;
}
.model-cover .model-box {
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  animation: animatetop 0.4s;
  animation: animatetop 0.4s;
  animation: animatetop 0.4s;
  animation: animatetop 0.4s;
  animation: animatetop 0.4s;
  background: white;
  margin: 0 auto;
  max-width: 420px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  top: 14%;
}
.model-cover .model-box .corner-button {
  border-color: hsl(0, 0%, 95%) hsl(0, 0%, 95%) transparent transparent;
  border-style: solid;
  border-width: 24px;
  height: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 0;
}
.model-cover .model-box .modal-header {
  padding: 30px 46px 24px 30px;
  position: relative;
}
.model-cover .model-box .modal-header > h2 {
  font-size: 1.5em;
  font-weight: normal;
  margin: 0 !important;
  padding: 0;
}
.model-cover .model-box .modal-body {
  height: 100%;
  margin-top: 0 !important;
  padding: 0 30px 20px;
  padding-bottom: 60px;
  position: relative;
  width: 100%;
}
.model-cover .model-box .modal-body p {
  margin-top: 0 !important;
}
.model-cover .model-box .close {
  background: none;
  border: 0;
  font-size: 0;
  height: 48px;
  position: absolute;
  right: -24px;
  top: -24px;
  width: 48px;
}
.model-cover .model-box .close::before {
  color: hsl(204.9, 94.4%, 35.1%);
  font-size: 20px;
  margin-right: 0;
  position: absolute;
  right: 3px;
  top: 3px;
}
.model-cover .model-box .close:focus {
  outline: 1px dotted #0d0d0d;
}

.modal-footer {
  background: hsl(0, 0%, 95%);
  border-radius: 8px;
  border-top: 1px solid #d2d2d2;
  bottom: 0;
  padding: 20px 30px;
  position: relative;
  width: 100%;
}
.modal-footer .btn-click {
  float: right;
}

@media (max-width: 1024px) {
  .btn-group {
    display: block;
    text-align: center;
  }
  .btn-group .btn {
    display: block;
    float: none;
    margin-left: auto !important;
    margin-right: auto !important;
    width: 100%;
  }
  .modal-body {
    height: 100%;
    padding: 0 17px 20px !important;
  }
  .modal-header {
    padding: 15px 46px 24px 17px !important;
  }
  .modal-footer {
    padding: 20px 17px 20px 20px !important;
  }
}
@keyframes animatetop {
  from {
    opacity: 0;
    top: -300px;
  }
  to {
    opacity: 1;
    top: 30%;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/alert-modal/alert-modal.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJA;EACE,8BAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;AAkJF;AAhJE;EFuBE,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EEpBA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AA0JJ;AAxJI;EACE,qEAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,QAAA;AA0JN;AAvJI;EACE,4BAAA;EACA,kBAAA;AAyJN;AAtJI;EACE,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;AAwJN;AArJI;EACE,YAAA;EACA,wBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;AAuJN;AArJM;EACE,wBAAA;AAuJR;AAlJI;EACE,gBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AAoJN;AAlJM;EACE,+BAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AAoJR;AAjJM;EACE,2BAAA;AAmJR;;AA5IA;EACE,2BAAA;EACA,kBAAA;EACA,6BAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AA+IF;AA7IE;EACE,YAAA;AA+IJ;;AF1NI;EEgFF;IACE,cAAA;IACA,kBAAA;EA8IF;EA5IE;IACE,cAAA;IACA,WAAA;IACA,4BAAA;IACA,6BAAA;IACA,WAAA;EA8IJ;EA1IA;IACE,YAAA;IACA,+BAAA;EA4IF;EAzIA;IACE,uCAAA;EA2IF;EAxIA;IACE,uCAAA;EA0IF;AACF;AAzHA;EACE;IACE,UAAA;IACA,WAAA;EAqIF;EAlIA;IACE,UAAA;IACA,QAAA;EAoIF;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","\n@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.model-cover {\n  background: rgba(0, 0, 0, .5);\n  height: 100%;\n  left: 0;\n  padding: 0 15px;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 9999;\n\n  .model-box {\n    @include vendor-prefix('border-radius', '8px');\n    @include vendor-prefix('animation', 'animatetop 0.4s');\n    background: color(default, light);\n    margin: 0 auto;\n    max-width: 420px;\n    overflow: auto;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    position: relative;\n    top: 14%;\n\n    .corner-button {\n      border-color: color(default, base) color(default, base) transparent transparent;\n      border-style: solid;\n      border-width: 24px;\n      height: 0;\n      position: absolute;\n      right: 0;\n      top: 0;\n      width: 0;\n    }\n\n    .modal-header {\n      padding: 30px 46px 24px 30px;\n      position: relative;\n    }\n\n    .modal-header > h2 {\n      font-size: 1.5em;\n      font-weight: normal;\n      margin: 0 !important;\n      padding: 0;\n    }\n\n    .modal-body {\n      height: 100%;\n      margin-top: 0 !important;\n      padding: 0 30px 20px;\n      padding-bottom: 60px;\n      position: relative;\n      width: 100%;\n\n      p {\n        margin-top: 0 !important;\n      }\n\n    }\n\n    .close {\n      background: none;\n      border: 0;\n      font-size: 0;\n      height: 48px;\n      position: absolute;\n      right: -24px;\n      top: -24px;\n      width: 48px;\n\n      &::before {\n        color: color(secondary, base);\n        font-size: 20px;\n        margin-right: 0;\n        position: absolute;\n        right: 3px;\n        top: 3px;\n      }\n\n      &:focus {\n        outline: 1px dotted darken(color(inverse, dark), 15%);\n      }\n\n    }\n  }\n}\n\n.modal-footer {\n  background: color(default, base);\n  border-radius: 8px;\n  border-top: 1px solid color(default, dark);\n  bottom: 0;\n  padding: 20px 30px;\n  position: relative;\n  width: 100%;\n\n  .btn-click {\n    float: right;\n  }\n}\n\n @include respond-to(small) {\n  .btn-group {\n    display: block;\n    text-align: center;\n\n    .btn {\n      display: block;\n      float: none;\n      margin-left: auto !important;\n      margin-right: auto !important;\n      width: 100%;\n    }\n  }\n\n  .modal-body {\n    height: 100%;\n    padding: 0 17px 20px !important;\n  }\n\n  .modal-header {\n    padding: 15px 46px 24px 17px !important;\n  }\n\n  .modal-footer {\n    padding: 20px 17px 20px 20px !important;\n  }\n }\n\n// Add Animation\n\n@-webkit-keyframes animatetop { //TODO: Need to write common mixing function\n  from {\n    opacity: 0;\n    top: -300px;\n  }\n\n  to {\n    opacity: 1;\n    top: 30%;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    opacity: 0;\n    top: -300px;\n  }\n\n  to {\n    opacity: 1;\n    top: 30%;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
